import { fadeIn } from './animation/fadeIn';
import { fadeOut } from './animation/fadeOut';
import { addEventListenerBath, removeEventListenerBath } from './helper/event';

// eslint-disable-next-line max-lines-per-function
export function mountModal() {
  let zIndex = 10000;
  let hiding = false;

  const modalCloseEvents: Record<string, (() => void) | (() => () => void)> = {};
  const modalOpenEvents: Record<string, () => void> = {};

  function addModalOpenEvent(name: string, callback: () => void) {
    modalOpenEvents[name] = callback;
  }
  /** 如果再返回一个函数，则等取消再执行 */
  function addModalCloseEvent(name: string, callback: (() => void) | (() => () => void)) {
    modalCloseEvents[name] = callback;
  }

  function showModal(_el: string | HTMLDivElement | null) {
    const el =
      typeof _el === 'string' ? document.querySelector<HTMLDivElement>(`.modal[data-modal="${_el}"]`) : _el;
    if (!el) {
      console.error('modal not found', _el);
      return;
    }
    zIndex += 1;
    const customIndex = el.dataset.index;

    el.style.zIndex = customIndex || String(zIndex);
    // $('body').addClass('h-[100vh]');
    // document.body.classList.add('overflow-hidden');
    // document.documentElement.classList.add('overflow-hidden');
    fadeIn({
      element: el,
    });
  }

  function hideModal(target: HTMLDivElement) {
    // 防止连续点击触发多次触发回调
    if (hiding) {
      return;
    }
    hiding = true;
    fadeOut({
      element: target,
    });
    const targetName = target.dataset.modal || '';
    if (modalCloseEvents[targetName]) {
      const result = modalCloseEvents[targetName]();
      if (typeof result === 'function') {
        setTimeout(() => {
          result();
        }, 300);
      }
    }
    setTimeout(() => {
      hiding = false;
    }, 300);
    // $('body').removeClass('h-[100vh]');
    // document.body.classList.remove('overflow-hidden');
    // document.documentElement.classList.remove('overflow-hidden');
  }

  /** 点击透明容器，隐藏 */
  addEventListenerBath({
    selector: '.modal',
    callback: (e) => {
      hideModal(e.currentTarget as HTMLDivElement);
    },
    event: 'click',
  });
  addEventListenerBath({
    selector: '.modal',
    callback: (e) => {
      e.preventDefault();
      e.stopPropagation();
    },
    event: 'touchmove',
  });
  addEventListenerBath({
    selector: '.modal-content',
    callback: (e) => {
      e.stopPropagation();
    },
    event: 'click',
  });
  addEventListenerBath({
    selector: '.modal-content',
    callback: (e) => {
      e.stopPropagation();
    },
    event: 'touchmove',
  });
  // document.querySelector('.modal')?.addEventListener('click', (e) => {
  //   hideModal(e.currentTarget as HTMLDivElement);
  // });

  // document.querySelector('.modal')?.addEventListener('touchmove', (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  // });

  // /** 点击内容，不冒泡到容器 */
  // document.querySelector('.modal-content')?.addEventListener('click', (e) => {
  //   e.stopPropagation();
  // });

  // document.querySelector('.modal-content')?.addEventListener('touchmove', (e) => {
  //   e.stopPropagation();
  // });

  // document.querySelector('body')?.addEventListener('scroll', (e) => {
  //   if ((e.currentTarget as HTMLDivElement).classList.contains('modal')) {
  //     e.preventDefault();
  //   }
  // });

  document.querySelector('body')?.addEventListener('touchmove', (e) => {
    if ((e.currentTarget as HTMLDivElement).classList.contains('modal')) {
      e.preventDefault();
    }
  });

  function openModal(e: MouseEvent) {
    const el = e.currentTarget as HTMLDivElement;
    const targetEl = el.dataset.modalTarget;

    if (!targetEl) {
      console.error('no target modal');
      return;
    }

    if (modalOpenEvents[targetEl]) {
      try {
        modalOpenEvents[targetEl]();
      } catch (err) {
        console.error('modal open error:', err);
      }
    }

    showModal(targetEl);
  }

  /** 动态插入 dom 的时候，需要重新注册 */
  function registerModalEvent() {
    removeEventListenerBath({
      selector: '.modal-btn',
      callback: openModal,
      event: 'click',
    });
    addEventListenerBath({
      selector: '.modal-btn',
      callback: openModal,
      event: 'click',
    });

    addEventListenerBath({
      selector: '.modal-close',
      event: 'click',
      callback: (e) => {
        const el = e.target as HTMLDivElement;
        const parent = el.closest('.modal');
        if (parent) {
          hideModal(parent as HTMLDivElement);
        }
        // let parent: HTMLDivElement | null = el.parentElement as HTMLDivElement;
        // while (parent) {
        //   if (parent.classList.contains('modal')) {
        //     // parent.fadeOut();
        //     hideModal(parent);
        //     parent = null;
        //   } else {
        //     parent = parent.parentElement as HTMLDivElement;
        //   }
        // }
      },
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    registerModalEvent();
  });

  return {
    addModalOpenEvent,
    addModalCloseEvent,
    openModal,
    hideModal,
    showModal,
    registerModalEvent,
  };
}
